<template>
  <div>
    <transition name="fade">
      <div class="splash-screen">
        <div class="splash-content">
          <div class="icon-box">
            <car-front-flat />
          </div>
          <p class="unavailable-description">{{ $t('customerInfoStep.bookingBlockedMsg') }}</p>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import CarFrontFlat from '../icons/CarFrontFlat.vue';

export default {
  name: 'BlockedFromBooking',
  components: {
    CarFrontFlat,
  },
  props: {
    accountName: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.splash-screen {
  display: flex;
  align-items: center;
  justify-content: center;
}
.splash-screen {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.unavailable-description {
  font-size: 18px;
  color: #2d3139;
  font-weight: 600;
}
.icon-box {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #003699;
  background: #e5eeff;
  border-radius: 8px;
  margin: 28px auto;
  width: 60px;
  height: 60px;
}
</style>
